/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Receipt_One_Seat_UntilInputs */



/**
* | output |
* | --- |
* | "1 seat until {date}" |
*
* @param {Receipt_One_Seat_UntilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_one_seat_until = /** @type {((inputs: Receipt_One_Seat_UntilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_One_Seat_UntilInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`1 Platz bis ${i?.date}`)
	return /** @type {LocalizedString} */ (`1 seat until ${i?.date}`)
});